import React from 'react';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import SelectField from 'components/pure/utils/form/SelectField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import './TeamMoveDialog.styl';

export default class TeamMoveDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {team, departments, onRequestClose} = this.props;
    const options = departments.map(department => ({
      label: department.name,
      value: department.id,
    }));
    return !team ? null : (
      <Dialog
        title="Move Team to Different Department"
        className="team-move-dialog"
        open={!!team}
        closeButton={true}
        onRequestClose={onRequestClose}
        actions={[
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            disabled={this.props.isTeamSaving}
            onClick={() => this.props.updateTeam(team).then(onRequestClose)}>
            Save
          </Button>,
          <Button variant="outlined" className="ev-button" onClick={onRequestClose}>
            Cancel
          </Button>,
        ]}>
        <FieldContainer label="Department:">
          <SelectField
            value={team.departmentId}
            options={options}
            hideResetButton={true}
            tether={true}
            onChange={this.props.stageDepartmentToReceive}
          />
        </FieldContainer>
      </Dialog>
    );
  }
}
